import {
    useEffect,
    useState
} from 'react';

import {useParams} from 'react-router-dom';

import {
    Anchor,
    Button,
    Grid,
    Group,
    Stack
} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useDomainName} from '../hooks/useDomainName';
import {useDomainNamesSelection} from '../hooks/useDomainNamesSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {lookupDnsInformation} from "../services/DomainNamesService.ts";
import {IpInfoModal} from '../components/IpInfoModal.tsx';

export const EditPage = () => {

    const [dnsInfo, setDnsInfo] = useState<{ address: string, family: number } | null>(null)

    const {id: domainNameId} = useParams();

    if (typeof domainNameId === 'undefined') {
        throw new Error('domainNameId is required parameter');
    }

    const {
        record: domainName,
        fetchRecord,
        updateRecord,
    } = useDomainName(domainNameId);

    const {handleClearSelection} = useDomainNamesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [domainNameId]);

    const handleLookupByHostname = async () => {
        const result = await lookupDnsInformation(domainName.name)
        setDnsInfo(result)
    }

    if (!domainName) {
        return <PlatformLoader message='Loading domain name...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={domainName.name ? domainName.name : domainName.id}
            pageNavigation={<EditPageNavigation component={domainName}/>}
            tools={tools}
        >


            {mode === 'view' ?


                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={domainName}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <SimplePageContentWrapper>
                            <Stack gap={'xl'}>
                                <Anchor href={`http://${domainName.name}`}
                                        target={'_blank'}>{`http://${domainName.name}`}</Anchor>
                                <br/>
                                <Group>
                                    <Button onClick={handleLookupByHostname}>DNS Lookup</Button>
                                    {dnsInfo && <Group>
                                        <div>{dnsInfo.address}</div>
                                        <IpInfoModal ipAddress={dnsInfo.address}/></Group>}
                                </Group>
                            </Stack>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>


                :
                <RecordForm
                    record={domainName}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
